<section class="auction-lot-info">
  <div class="auction-lot-info__accent"></div>

  <div class="auction-lot-info__body">
    <div class="auction-lot-info__badge">
      <i class="iconsax auction-lot-info__badge-icon" icon-name="chart-success"></i>
      <span>{{ 'auctions.highPerformanceLot' | translate }}</span>
    </div>

    <h1 class="auction-lot-info__title">
      {{ auction()?.title | translateData }}
    </h1>

    <p class="auction-lot-info__description">
      {{ auction()?.description | translateData }}
    </p>

    @if (auction()?.business) {
      <div class="auction-lot-info__seller">
        <div class="auction-lot-info__seller-avatar">
          @if (auction()?.business?.logo?.url) {
            <img
              [ngSrc]="(auction()?.business?.logo?.url | imageSource) || ''"
              width="44"
              height="44"
              [alt]="(auction()?.business?.title | translateData) || ''" />
          } @else {
            <i class="iconsax" icon-name="building-4"></i>
          }
        </div>

        <div class="auction-lot-info__seller-content">
          <div class="auction-lot-info__seller-row">
            <span class="auction-lot-info__seller-name">
              {{ auction()?.business?.title | translateData }}
            </span>
            @if (auction()?.business?.is_verfied) {
              <span class="auction-lot-info__seller-grade">{{
                'auctions.goldPartner' | translate
              }}</span>
            }
          </div>
          <p class="auction-lot-info__seller-meta">
            {{ 'auctions.verifiedBusinessPartner' | translate }}
            @if (auction()?.business?.city?.name || auction()?.business?.country?.name) {
              <span>
                •
                {{
                  (auction()?.business?.city?.name | translateData) ||
                    (auction()?.business?.country?.name | translateData)
                }}
              </span>
            }
          </p>
        </div>
      </div>
    }
  </div>
</section>
